var app = angular.module("digitalPassApp", [
  "ngRoute",
  "ngSanitize",
  "ngCookies",
  "cp.ngConfirm",
  "datatables",
  //'ngAnimate',
  "ui.bootstrap",
  "ngStorage",
  "ngMeta", //https://vinaygopinath.github.io/ngMeta/#/
  "angular-loading-bar", //https://github.com/chieffancypants/angular-loading-bar
  "angular-growl", //https://fritz.ninja/angular-growl-2/
  "angularjs-crypto", //https://www.phpflow.com/misc/angular/encryption-decryption-using-crypto-js-in-angularjs/
  "isoCurrency",
  "ui.swiper",
  "frontPageTemplateDirective",
  "ngSentry",
  "angular-inview",
]);

app.run([
  "ngMeta",
  "$rootScope",
  "$anchorScroll",
  function (ngMeta, $rootScope, $anchorScroll) {
    ngMeta.init();

    $rootScope.$on("$locationChangeSuccess", function () {
      $anchorScroll();
    });
  },
]);

app.constant("config", {
  fstreamAPI: apiUrl,
  publicApiUrl: publicApiUrl,
  key: "oiceeoczycbnbgfayphsyeoickajgjuq", //encryption key
  appVersion: "202304300920",
  fullSite: fullSite,
});

app.directive("headerBackground", [
  "$localStorage",
  function ($localStorage) {
    var microsite = JSON.parse($localStorage.microsite);
    var siteConfig = microsite.microsite;
    return {
      restrict: "C",
      scope: {},
      link: function (scope, element, attrs) {
        if (siteConfig.headerBackgroundColor != "") {
          var color = siteConfig.headerBackgroundColor;
        } else {
          var color = "#2bbbad";
        }
        //return 'style="color: ' + color + ' !important"';
        attrs.$set("style", "background-color:" + color);
      },
    };
  },
]);

app.directive("headerText", [
  "$localStorage",
  function ($localStorage) {
    var microsite = JSON.parse($localStorage.microsite);
    var siteConfig = microsite.microsite;
    return {
      restrict: "C",
      scope: {},
      link: function (scope, element, attrs) {
        if (siteConfig.headerTextColor != "") {
          var color = siteConfig.headerTextColor;
        } else {
          var color = "#FFFFFF";
        }
        //return 'style="color: ' + color + ' !important"';
        attrs.$set("style", "color:" + color);
      },
    };
  },
]);

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  var test = Math.round(n) / multiplicator;
  return +test.toFixed(digits);
}

app.config([
  "growlProvider",
  function (growlProvider) {
    growlProvider.globalTimeToLive(5000);
    growlProvider.globalDisableCountDown(true);
  },
]);

app.config([
  "cfpLoadingBarProvider",
  function (cfpLoadingBarProvider) {
    cfpLoadingBarProvider.spinnerTemplate = `<div style="text-align:center"><div class="preloader-wrapper big active">
        <div class="preloader-wrapper big active">
            <div class="preloader-wrapper big active">
                <div class="preloader-wrapper big active">
                    <div class="spinner-layer spinner-green-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div><div class="gap-patch">
                        <div class="circle"></div>
                    </div><div class="circle-clipper right">
                        <div class="circle"></div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div></div>`;
  },
]);

app.config([
  "$httpProvider",
  function ($httpProvider) {
    $httpProvider.defaults.withCredentials = true;
  },
]);

app.filter("titlecase", function () {
  return function (input) {
    var smallWords =
      /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

    input = input.toLowerCase();
    return input.replace(
      /[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g,
      function (match, index, title) {
        if (
          index > 0 &&
          index + match.length !== title.length &&
          match.search(smallWords) > -1 &&
          title.charAt(index - 2) !== ":" &&
          (title.charAt(index + match.length) !== "-" ||
            title.charAt(index - 1) === "-") &&
          title.charAt(index - 1).search(/[^\s-]/) < 0
        ) {
          return match.toLowerCase();
        }

        if (match.substr(1).search(/[A-Z]|\../) > -1) {
          return match;
        }

        return match.charAt(0).toUpperCase() + match.substr(1);
      }
    );
  };
});

app.factory("getIPInfo", [
  "$rootScope",
  "$http",
  "$q",
  "config",
  function ($rootScope, $http, $q, config) {
    var deferred = $q.defer();
    $http({
      method: "GET",
      url: config.fstreamAPI + "getIP",
      headers: {
        "Content-Type": "application/json", //x-www-form-urlencoded
        Accept: "application/json",
        Authorization: config.fsKey,
      },
    }).then(function mySucces(response) {
      deferred.resolve(response.data.data);
    });

    return deferred.promise;
  },
]);

app.filter("getMyTime", function () {
  return function (start) {
    let guessTZ = moment().tz(moment.tz.guess());
    let tz = guessTZ.format("z");
    let startTime = moment.unix(start).format("LLLL");
    return startTime + " " + tz;
  };
});

app.filter("escape", function () {
  return window.encodeURI;
});

app.filter("unescape", [
  "$sce",
  function ($sce) {
    return function (text) {
      if (text !== undefined) {
        let decoded = decodeURIComponent(text.replace(/\+/g, " "));
        return $sce.trustAsHtml(decoded);
      } else {
        return "";
      }
    };
  },
]);

app.filter("contentType", function () {
  return function (contentType) {
    switch (contentType) {
      case "ondemand":
        return "Video On Demand";
        break;
      case "live":
        return "Live Stream";
        break;
      case "subscription":
        return "Subscription";
        break;
      default:
        return "";
      // code block
    }
  };
});

app.filter("contentBadge", function () {
  return function (contentType) {
    switch (contentType) {
      case "ondemand":
        return '<span class="badge primary-color"><i class="fas fa-play-circle"></i> Video On Demand</span>';
        break;
      case "live":
        return '<span class="badge warning-color"><i class="fas fa-satellite-dish"></i> Live Stream</span>';
        break;
      case "subscription":
        return '<span class="badge secondary-color"><i class="fas fa-list-alt"></i> Subscription</span>';
        break;
      default:
        return "";
      // code block
    }
  };
});

app.filter("currencySymbol", function () {
  return function (currency_name) {
    var currency_symbols = {
      USD: "$", // US Dollar
      AUD: "$", // Aust
      EUR: "€", // Euro
      CRC: "₡", // Costa Rican Colón
      GBP: "£", // British Pound Sterling
      ILS: "₪", // Israeli New Sheqel
      INR: "₹", // Indian Rupee
      JPY: "¥", // Japanese Yen
      KRW: "₩", // South Korean Won
      NGN: "₦", // Nigerian Naira
      PHP: "₱", // Philippine Peso
      PLN: "zł", // Polish Zloty
      PYG: "₲", // Paraguayan Guarani
      THB: "฿", // Thai Baht
      UAH: "₴", // Ukrainian Hryvnia
      VND: "₫", // Vietnamese Dong
    };

    if (currency_symbols[currency_name] !== undefined) {
      return currency_symbols[currency_name];
    } else {
      return "";
    }
  };
});

app.factory("decrypt", [
  "$localStorage",
  "config",
  "$q",
  "$location",
  "$window",
  "$http",
  function ($localStorage, config, $q, $location, $window, $http) {
    return {
      getKey: function (scope) {
        if ($localStorage.fsenc === undefined) {
          return false;
        }
        var CryptoJSAesJson = {
          stringify: function (cipherParams) {
            var j = {
              ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
            };
            if (cipherParams.iv) j.iv = cipherParams.iv.toString();
            if (cipherParams.salt) j.s = cipherParams.salt.toString();
            return JSON.stringify(j);
          },
          parse: function (jsonStr) {
            var j = JSON.parse(jsonStr);
            var cipherParams = CryptoJS.lib.CipherParams.create({
              ciphertext: CryptoJS.enc.Base64.parse(j.ct),
            });
            if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
            if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
            return cipherParams;
          },
        };

        var decrypted = JSON.parse(
          CryptoJS.AES.decrypt($localStorage.fsenc, config.key, {
            format: CryptoJSAesJson,
          }).toString(CryptoJS.enc.Utf8)
        );

        return decrypted;
      },
    };
  },
]);
app.filter("range", function () {
  return function (input, total) {
    total = parseInt(total);
    for (var i = 0; i < total; i++) input.push(i);
    return input;
  };
});

app.factory("getSiteDetails", [
  "$localStorage",
  "config",
  "$q",
  "$http",
  "FiveStreamApiFactory",
  "LocalStorageFactory",
  "$rootScope",
  function (
    $localStorage,
    config,
    $q,
    $http,
    FiveStreamApiFactory,
    LocalStorageFactory,
    $rootScope
  ) {
    $rootScope.accessItems = [];

    const getPlaylist = (id, localStorageKey) => {
      let q = $q.defer();
      if (LocalStorageFactory.isExpired(localStorageKey)) {
        FiveStreamApiFactory.getPlaylist(siteID, id).then(
          (data) => {
            LocalStorageFactory.update(localStorageKey, data);
            q.resolve(data);
          },
          (err) => {
            q.reject(err);
          }
        );
      } else {
        const data = LocalStorageFactory.getByKey(localStorageKey);
        q.resolve(data);
      }
      return q.promise;
    };

    const getPageElements = (siteID, page, localStorageKey, forceLoad) => {
      let q = $q.defer();
      if (forceLoad || LocalStorageFactory.isExpired(localStorageKey)) {
        FiveStreamApiFactory.getPageElements(siteID, page).then(
          (data) => {
            LocalStorageFactory.update(localStorageKey, data);
            q.resolve(data);
          },
          (err) => {
            q.reject(err);
          }
        );
      } else {
        const data = LocalStorageFactory.getByKey(localStorageKey);
        q.resolve(data);
      }
      return q.promise;
    };

    const getCustomerContent = () => {
      FiveStreamApiFactory.getCustomerContent()
        .then(({ data }) => {
          $rootScope.accessItems = data;
        })
        .catch((err) => {
          $rootScope.accessItems = [];
        });
    };

    return {
      getPlaylistContent: function (id) {
        return getPlaylist(id, id);
      },

      getHomePageElements: function (siteID) {
        return getPageElements(siteID, "home", "home-elements");
      },
      getDonatePageElements: function (siteID) {
        return getPageElements(siteID, "donate", "donate-elements");
      },
      getFaqPageElements: function (siteID) {
        return getPageElements(siteID, "faq", "faq-elements");
      },
      getContactusPageElements: function (siteID) {
        return getPageElements(siteID, "contactus", "contactus-elements");
      },
      getPlayPageElements: function (siteID) {
        return getPageElements(siteID, "play", "play-elements");
      },
      getCustomPageElements: function (siteID, page, forceLoad) {
        return getPageElements(siteID, page, "play-elements", forceLoad);
      },
      getCustomerContent: function () {
        return getCustomerContent();
      },
      getSubscribePageElements: function (siteID) {
        return getPageElements(siteID, "subscribe", "subscribe-elements");
      },

      //TODO Remove this once playlist element has been implemented
      getPlaylistsContent: function (playlistIds) {
        if (playlistIds.length) {
          let allPlaylists = [];
          playlistIds.forEach((playlist) => {
            allPlaylists.push(getPlaylist(playlist, playlist));
          });

          return $q.all(allPlaylists);
        } else {
          return $q.reject("No frontpage playlist content set");
        }
      },

      // the microsite localStorage key is used everywhere
      // so this one might need to be treated differently
      getMicrosite: function (id, key) {
        let q = $q.defer();

        var expired = false;
        var now = new Date();
        if ($localStorage.microsite !== undefined) {
          var microsite = JSON.parse($localStorage.microsite);
          if (now.getTime() > microsite.expiry) {
            localStorage.removeItem("microsite");
            expired = true;
          }
        } else {
          expired = true;
        }

        expired = true;

        if (expired === true) {
          $http({
            withCredentials: false,
            method: "GET",
            url: config.publicApiUrl + "getMicrosite/" + id,
            headers: {
              "Content-Type": "application/json", //x-www-form-urlencoded
              Accept: "application/json",
              Authorization: key,
            },
          }).then(
            function mySucces(response) {
              const item = {
                microsite: response.data.data,
                expiry: now.getTime() + 600000, //10 mins
              };

              $localStorage.microsite = JSON.stringify(item);
              q.resolve(response.data.data);
            },
            function myError(response) {
              q.reject("no content");
            }
          );
          return q.promise;
        } else {
          q.resolve($localStorage.microsite);
          return q.promise;
        }
      },
    };
  },
]);
